import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function AlertIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M15.1201 6.62012c0-2.76-2.24-5-5-5-2.75998 0-4.99998 2.24-4.99998 5 0 5.82998-2.5 7.49998-2.5 7.49998H17.6201s-2.5-1.67-2.5-7.49998ZM11.5699 17.46c-.46.8-1.48 1.07-2.27997.61-.25-.15-.46-.35-.61-.61"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
